module.exports = __webpack_public_path__ + "37542a749de4af54582595648fb51241.png";